/**
 * @generated SignedSource<<90153777901f7414ee67fce6598edc3e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type testPageDeleteMutation$variables = {
  productID: string;
};
export type testPageDeleteMutation$data = {
  readonly deleteProduct: {
    readonly id: string;
  } | null;
};
export type testPageDeleteMutation = {
  response: testPageDeleteMutation$data;
  variables: testPageDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productID"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "productID",
        "variableName": "productID"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "deleteProduct",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "testPageDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "testPageDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7f96a05586efbf8f2b5854858adcf37e",
    "id": null,
    "metadata": {},
    "name": "testPageDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation testPageDeleteMutation(\n  $productID: String!\n) {\n  deleteProduct(productID: $productID) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "a10068840cc14242aaaf58f7584c0e3a";

export default node;
